export const groupParticipantsLoading =  ({store})  => store.groupParticipantsReducer.loading;

export const groupParticipantsError =  ({store})  => store.groupParticipantsReducer.error;

export const groupParticipantsData =  ({store})  => store.groupParticipantsReducer.data;